var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:18px;fill:currentColor;font-family:BureauGrot-Light, BureauGrot;font-weight:300;letter-spacing:0.03em;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-2.05 -5.9)"
  }, "MEETING"), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.51,186.24V175.76a19.89,19.89,0,0,0-19.83-19.84H97.81A19.9,19.9,0,0,0,78,175.76v10.48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 109.19,
    cy: 131.11,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 166.48,
    cy: 86.69,
    r: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.68,95.08V84.6c0-10.92-5.82-19.84-12.93-19.84H102.51c-7.12,0-12.93,8.92-12.93,19.84V95.08"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 110.08,
    cy: 39.95,
    r: 14.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "56.88 176.73 76.16 96.19 142.68 96.19 161.29 176.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.32,146.87h28.26v-19h0a18,18,0,0,0-34.37-6.79"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 52.81,
    cy: 86.24,
    r: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,146.42H34.71v-19h0a18,18,0,0,1,34.37-6.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/MEETING.e429d2ba3914ce1ab18e9ab1529b6f36.svg";
export { ForwardRef as ReactComponent };